import React from 'react';
import { browserHistory } from 'react-router';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import DataTableUtil from '../DataTableUtil';
import * as actions from '../redux/actions';
import Util from '../Util';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import $ from 'jquery';
import ReactDOM from 'react-dom';

const FILTER_COLUMNS = [
  'ip',
  'hostname',
  'authType',
  'timezone',
  'memTotal',
  'diskTotal',
  'uptime',
  'linuxdashVer',
  'lastFetchedDateTime',
];
const DEFAULT_COL_SORT_DIRS = { memUsedPercent: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1276;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle = 'ServerTable') {
  return tableTitle + '-filterText';
}

function getColSortKey(tableTitle = 'ServerTable') {
  return tableTitle + '-columnSortDirs';
}

function getHostInfoKey(hostInfo) {
  let key = hostInfo.id || hostInfo.fingerprint || hostInfo.ip + '-' + hostInfo.macAddress;
  return key;
}

function getTrashIconKey(hostInfo) {
  return 'trash-icon' + '-' + getHostInfoKey(hostInfo);
}

function getRefreshIconKey(hostInfo) {
  return 'refresh-icon' + '-' + getHostInfoKey(hostInfo);
}

class ServerTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterText: Storage.getSessionItem(getFilterKey(props.tableTitle)) || '',
      columnSortDirs: Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  handleDeleteRow(hostInfo, ref, event) {
    event.stopPropagation();
    const { dispatch } = this.props;
    let doDelete = confirm(
      'Delete ' + hostInfo.hostname + ' ' + hostInfo.ip + ' ' + hostInfo.macAddress + '?'
    );
    if (doDelete) {
      let promise = dispatch(actions.deleteHostInfo(hostInfo.id));
      let key = getTrashIconKey(hostInfo);
      let $icon = $(ReactDOM.findDOMNode(ref[key]));
      $icon.addClass('fa-spin');
      $icon.removeClass('animated tada');
      promise
        .then(() => {
          $icon.removeClass('fa-spin');
          $icon.addClass('animated tada');
        })
        .catch((e) => {
          $icon.removeClass('fa-spin');
          $icon.addClass('animated tada');
          alert('Error: Delete failed! ' + e.message); // todo: use alert component
        });
    }
  }

  handleRefreshIconClick(hostInfo, ref, event) {
    event.stopPropagation();
    const { dispatch } = this.props;
    let promise = dispatch(actions.fetchInfo(hostInfo));
    let key = getRefreshIconKey(hostInfo);
    let $icon = $(ReactDOM.findDOMNode(ref[key]));
    $icon.addClass('fa-spin');
    $icon.removeClass('animated tada');
    promise
      .then(() => {
        $icon.removeClass('fa-spin');
        $icon.addClass('animated tada');
      })
      .catch((e) => {
        $icon.removeClass('fa-spin');
        $icon.addClass('animated tada');
        alert('Error: Refresh failed! ' + e.message); // todo: use alert component
      });
  }

  handleViewHostInfo(hostInfo) {
    browserHistory.push(`/id/${hostInfo.id}/overview`);
  }

  render() {
    const { filterText, columnSortDirs } = this.state;
    const { hostInfoList } = this.props;

    let {auth: {user}} = this.props;
    // hide ability to add/remove host for front level support role
    let isFrontLevelSupport = user.isFrontLevelSupportRole();

    const dataList = DataTableUtil.filterList(
      hostInfoList,
      filterText,
      FILTER_COLUMNS,
      columnSortDirs
    );
    const size = hostInfoList.length;

    // console.log(this.props.tableTitle + ' render: ' + new Date().toLocaleString());
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = this.props.tableHeight || DEFAULT_TABLE_HEIGHT;

    return (
      <div>
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div className='pure-g pure-u-1 card-label button-secondary'>
            <i className='fa fa-fw fa-server' />
            {this.props.tableTitle}
            <input
              className='table-search'
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
          </div>

          <Table
            rowsCount={dataList.length}
            rowHeight={50}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            {... this.props}>

            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={46}
              align='center'
            />
            <Column
              columnKey='ip'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.ip}>
                  IP Address
                </SortHeaderCell>
              }
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                return (
                  <Cell
                    {...props}
                    style={{ cursor: 'pointer', color: 'blue' }}
                    onClick={this.handleViewHostInfo.bind(this, hostInfo)}
                  >
                    {hostInfo.ip}
                  </Cell>
                );
              }}
              fixed={true}
              width={100}
              align='right'
            />
            <Column
              columnKey='hostname'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.hostname}>
                  Hostname
                </SortHeaderCell>
              }
              cell={<TextCell className='main-cell' dataList={dataList} field='hostname' />}
              fixed={true}
              width={220}
              align='right'
            />

            <Column
              columnKey='authType'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.authType}>
                  Auth Type
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='authType' />}
              fixed={true}
              width={60}
            />

            <Column
              columnKey='cpu5MinLoadAvgPercent'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.cpu5MinLoadAvgPercent}>
                  Load Avg 5 Min %
                </SortHeaderCell>
              }
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                let percent = hostInfo.cpu5MinLoadAvgPercent;
                return (
                  <Cell
                    {...props}
                    style={{ color: Util.calcLoadAvgColor(percent), fontWeight: 600 }}
                  >
                    {percent}
                  </Cell>
                );
              }}
              fixed={true}
              width={85}
              align='right'
            />
            <Column
              columnKey='cpu15MinLoadAvgPercent'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.cpu15MinLoadAvgPercent}>
                  Load Avg 15 Min %
                </SortHeaderCell>
              }
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                let percent = hostInfo.cpu15MinLoadAvgPercent;
                return (
                  <Cell {...props} style={{color: Util.calcLoadAvgColor(percent), fontWeight: 600}}>
                    {percent}
                  </Cell>
                );
              }}
              fixed={true}
              width={85}
              align='right'
            />
            <Column
              columnKey='memUsedPercent'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.memUsedPercent}>
                  Mem Used %
                </SortHeaderCell>
              }
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                let percent = hostInfo.memUsedPercent;
                return (
                  <Cell {...props} style={{color: Util.calcMemUsageColor(percent), fontWeight: 600}}>
                    {percent}
                  </Cell>
                );
              }}
              fixed={true}
              width={85}
              align='right'
            />
            <Column
              columnKey='memTotal'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.memTotal}>
                  Total Mem
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='memTotal' />}
              fixed={true}
              width={80}
              align='right'
            />
            <Column
              columnKey='diskUsedPercent'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.diskUsedPercent}>
                  Disk Used %
                </SortHeaderCell>
              }
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                let percent = hostInfo.diskUsedPercent;
                return (
                  <Cell {...props} style={{color: Util.calcDiskUsageColor(percent), fontWeight: 600}}>
                    {percent}
                  </Cell>
                );
              }}
              fixed={true}
              width={85}
              align='right'
            />
            <Column
              columnKey='diskTotal'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.diskTotal}>
                  Disk Total
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='diskTotal' />}
              fixed={true}
              width={80}
              align='right'
            />
{/*
            <Column
              columnKey="osVer"
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.osVer}>
                  OS Version
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field="osVer"/>}
              fixed={true}
              width={180}
            />
*/}

            <Column
              columnKey='uptime'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.uptime}>
                  Uptime
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='uptime' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='linuxdashVer'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.linuxdashVer}>
                  linuxdash
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='linuxdashVer' />}
              fixed={true}
              width={80}
            />
            <Column
              columnKey='lastFetchedDateTime'
              header={
                <SortHeaderCell
                  style={{ fontSize: 10 }}
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.lastFetchedDateTime}>
                  Last Successful Fetched
                </SortHeaderCell>
              }
              cell={(props) => {
                let host = dataList[props.rowIndex];
                //let noSec = host.lastFetchedDateTime.replace(/:[0-9]{2}$/, '');
                let xAgo = '';
                if (host.lastFetched) {
                  xAgo = Util.xUnitsOfTimeAgo(host.lastFetched);
                }
                return (
                  <Cell {...props}>
                    {host.isBadFetchStatus ? (
                      <span style={{ color: 'darkred' }} title={host.lastFetchedDateTime}>
                        {xAgo}
                      </span>
                    ) : (
                      <span style={{ color: '' }} title={host.lastFetchedDateTime}>
                        {xAgo}
                      </span>
                    )}
                  </Cell>
                );
              }}
              fixed={true}
              width={85}
            />

            <Column
              header={<Cell>Actions</Cell>}
              cell={(props) => {
                let hostInfo = dataList[props.rowIndex];
                let refreshKey = getRefreshIconKey(hostInfo);
                let trashIconKey = getTrashIconKey(hostInfo);
                let ref = {}; // for ref callback to get icon
                return (
                  <Cell {...props}>
                    <div
                      style={{ display: 'inline-block', padding: 8 }}
                      onClick={this.handleRefreshIconClick.bind(this, hostInfo, ref)}
                    >
                      <i
                        style={{ fontSize: '150%', color: '#363841' }}
                        className='fa fa-refresh'
                        ref={(c) => (ref[refreshKey] = c)}
                        title='Refresh'
                      />
                    </div>
                    {!isFrontLevelSupport && (
                      <div
                        style={{ display: 'inline-block', padding: 8 }}
                        onClick={this.handleDeleteRow.bind(this, hostInfo, ref)}
                      >
                        <i
                          style={{ color: '#363841', fontSize: '150%' }}
                          className='fa fa-trash-o '
                          ref={(c) => (ref[trashIconKey] = c)}
                          title='Delete'
                        />
                      </div>
                    )}
                  </Cell>
                );
              }}
              fixed={true}
              width={120}
            />
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-1-3'>
              {dataList.length < size ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries)
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-1-3'></div>
            <div className='pure-u-1-3' style={{ textAlign: 'right' }}>
              <a
                href='javascript:void(0)'
                className=''
                onClick={Util.downloadCSV.bind(this, hostInfoList, this.props.tableTitle)}
              >
                <i className='fa fa-fw fa-cloud-download' />
                Export CSV
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ServerTable;



// WEBPACK FOOTER //
// ./src/components/ServerTable.js